import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#030305] flex items-center justify-center" data-testid="auth-loading">
        <div className="w-10 h-10 rounded-full border-2 border-[#0A84FF] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
